<template>
  <div>
    <PageBanner :obj="obj"></PageBanner>
    <section class="container">
      <h1 class="solution_title">Customer Pain Points</h1>
      <Td :obj="info.painlist"></Td>
    </section>
    <section class="container">
      <h1 class="solution_title">Application Scenarios</h1>
      <Cj :obj="info.uselist"></Cj>
    </section>
    <section class="container">
      <h1 class="solution_title">Program Value</h1>
      <Jz :obj="info.project"></Jz>
    </section>
    <section class="container">
      <h1 class="solution_title">Recommended Products</h1>
      <ProductList :list="info.rec_pro" :loading="false"></ProductList>
    </section>
  </div>
</template>

<script>
import images from "@/assets/image/page_banner.png";
import image from "@/assets/image/home_product.png";
import Td from "@/components/solution/td.vue";
import Cj from "@/components/solution/cj.vue";
import Jz from "@/components/solution/jz.vue";
import service from "@/assets/js/service";

export default {
  data() {
    return {
      obj: {
        cn: "解决方案",
        en: "SOLUTION",
        link: "/solution",
        image: images,
        list: [],
      },
      list: [
        { image, name: "窄通道叉腿式 AGV", su_name: "YAB10", id: 11 },
        { image, name: "窄通道叉腿式 AGV", su_name: "YAB10", id: 11 },
        { image, name: "窄通道叉腿式 AGV", su_name: "YAB10", id: 11 },
      ],
      id: this.$route.query.id,
      info: {},
    };
  },
  components: { Td, Cj, Jz },
  methods: {
    async solutionIndex() {
      let res = await service.solutionIndex({ id: this.id });
      console.log(res.data.solutioninfo);
      this.obj.cn = res.data.banner.name;
      this.obj.en = res.data.banner.eng_title;
      this.obj.image = this.$baseURL + res.data.banner.thumb;
      this.obj.list = res.data.solution.map((item, index) => ({ id: item.id, cat_name: item.title, comp: "/solution" }));

      this.info = res.data.solutioninfo;
    },
  },
  created() {
    this.solutionIndex();
  },
  watch: {
    $route(to, from) {
      this.id = to.query.id;
    },
    id() {
      this.solutionIndex();
    },
  },
};
</script>

<style lang="less" scoped>
.solution_title {
  font-size: 30px;
  text-align: center;
  margin-bottom: 30px;
}
</style>